const faultWarningZh = {
  faultWarnLang: {
    请输入站点名称搜索: '请输入站点名称搜索',
    暂无数据: '暂无数据',
    重置站点告警: '重置站点告警',
    重置系统告警: '重置系统告警',
    历史告警: '历史告警',
    设备类型: '设备类型',
    全部: '全部',
    全选: '全选',
    告警等级: '告警等级',
    告警类型: '告警类型',
    故障状态: '故障状态',
    告警状态: '告警状态',
    处理建议: '处理建议',
    时间范围: '时间范围',
    开始时间: '开始时间',
    结束时间: '结束时间',
    查询: '查询',
    重置: '重置',
    站点系统: '站点系统',
    告警统计: '告警统计',
    告警列表: '告警列表',
    '已结束告警记录只保留近7日，更多告警信息请前往右上角告警历史查看': '已结束告警记录只保留近7日，更多告警信息请前往右上角告警历史查看',
    设备名称: '设备名称',
    告警标题: '告警标题',
    客户告警: '客户告警',
    告警开始时间: '告警开始时间',
    告警结束时间: '告警结束时间',
    操作: '操作',
    结束: '结束',
    删除: '删除',
    详情: '详情',
    结束告警: '结束告警',
    时区: '时区',
    请选择: '请选择',
    取消: '取消',
    确定: '确定',
    运维告警详情: '运维告警详情',
    返回: '返回',
    复制成功: '复制成功',
    请选择时间: '请选择时间',
    发生中: '发生中',
    已结束: '已结束',
    未分级: '未分级',
    一般: '一般',
    重要: '重要',
    严重: '严重',
    设备: '设备',
    业务: '业务',
    通讯: '通讯',
    运维处理: '运维处理',
    此操作将清除当前站点下全部系统的告警历史及统计数据是否确认清除: '此操作将清除当前站点下全部系统的告警历史及统计数据，是否确认清除？',
    提示: '提示',
    此操作前提是必须先选择指定站点系统: '此操作前提是必须先选择指定站点系统！',
    此操作将清除当前系统下全部系统的告警历史及统计数据是否确认清除: '此操作将清除当前系统下全部系统的告警历史及统计数据，是否确认清除？',
    结束时间不能小于开始时间: '结束时间不能小于开始时间',
    是否删除此告警: '是否删除此告警？',
    站点告警: '站点告警',
    告警筛选: '告警筛选',
    '时间范围只能选择1-7天': '时间范围只能修改1-7天',
    条: '条',
    告警类型: '告警类型',
    设备类型: '设备类型'
  }
}
export default faultWarningZh
